import Http from '@/utils/httpRequest'

const axios = new Http()
export default {
  // 咨询与投诉
  submitQs: data => {
    return axios.post('/suggestion/public/submitQs', data)
  },
  // 上传文件接口
  consultUpload: data => {
    return axios.post('/suggestion/public/Upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    })
  },
}
